/** giftName_v{version}-n{serial} (스냅샷 기준, 예: 선셋 티_v1-n51). giftName 없으면 giftId 사용. seqNo는 serial fallback */

export function resolveGiftSerialParts(source) {
  const root = source ?? {};
  const purchase = root.purchase;
  const gift = root.gift;

  const giftName = String(
    root.giftName ?? purchase?.giftName ?? gift?.giftName ?? ''
  ).trim();
  const giftId = String(
    root.giftId ?? purchase?.giftId ?? gift?.giftId ?? ''
  ).trim();
  const label = giftName || giftId;
  const version =
    root.giftVersion ??
    root.version ??
    purchase?.giftVersion ??
    purchase?.version ??
    gift?.version ??
    null;
  const serial =
    root.serial ??
    root.seqNo ??
    purchase?.serial ??
    purchase?.seqNo ??
    null;

  return { label, version, serial };
}

export function formatGiftSerial(source) {
  const { label, version, serial } = resolveGiftSerialParts(source);
  if (!label) return '';

  const hasVersion =
    version !== undefined && version !== null && String(version).trim() !== '';
  const hasSerial =
    serial !== undefined && serial !== null && String(serial).trim() !== '';

  if (hasVersion && hasSerial) {
    return `${label}_v${version}-n${serial}`;
  }
  if (hasVersion) {
    return `${label}_v${version}`;
  }
  if (hasSerial) {
    return `${label}-n${serial}`;
  }
  return label;
}

/** 테이블 셀 표시용 — 빈 값이면 '-' */
export function formatGiftSerialDisplay(source) {
  const formatted = formatGiftSerial(source);
  return formatted || '-';
}

/** 환불 목록 API row → giftName_v{version}-n{serial} 표시용 필드 정규화 */
export function normalizeRefundForSerial(source) {
  const row = source ?? {};
  return {
    ...row,
    giftName: row.giftName ?? row.gift?.giftName ?? null,
    giftId: row.giftId ?? row.purchase?.giftId ?? row.gift?.giftId ?? null,
    version:
      row.version ??
      row.giftVersion ??
      row.purchase?.version ??
      row.gift?.version ??
      null,
    serial: row.serial ?? row.seqNo ?? row.purchase?.serial ?? null,
  };
}

/** 환불 내역 기프트 시리얼 표시 */
export function formatRefundSerialDisplay(source) {
  return formatGiftSerialDisplay(normalizeRefundForSerial(source));
}

/** 화면 표기(상품명_v1-n51)로 입력한 검색어를 API가 해석하는 형식(상품명_1-51)으로 되돌린다 */
export function toGiftSerialSearchValue(input) {
  return String(input ?? '')
    .trim()
    .replace(/_v(\d+)-n(\d+)$/i, '_$1-$2')
    .replace(/_v(\d+)$/i, '_$1')
    .replace(/-n(\d+)$/i, '-$1');
}
